<template>
  <div>
    <b-form-group label="First Name" label-class="text-truncate label-required">
      <b-form-input v-model="firstName" required/>
    </b-form-group>

    <b-form-group label="Last Name" label-class="text-truncate label-required">
      <b-form-input v-model="lastName" required/>
    </b-form-group>

    <b-form-group label="Email" label-class="text-truncate label-required">
      <b-form-input v-model="email" required/>
    </b-form-group>

    <b-form-group label="Work Number" label-class="text-truncate label-required">
      <b-form-input v-model="phoneNumber"/>
    </b-form-group>

  </div>
</template>

<script>
export default {
  props: ['user'],

  data: function () {
    return {
      firstName: null,
      lastName: null,
      phoneNumber: null,
      email: null,
    }
  },

  created() {
    this.resetForm();
  },

  methods: {
    resetForm() {
      this.firstName = this.user.first_name;
      this.lastName = this.user.last_name;
      this.phoneNumber = this.user.phone_number;
      this.email = this.user.email;
    }
  },

  computed: {
    params() {
      return {
        first_name: this.firstName,
        last_name: this.lastName,
        phone_number: this.phoneNumber,
        email: this.email,
      }
    }
  }
}
</script>